import { jsxs as i, jsx as t } from "react/jsx-runtime";
import "../../utils/sectionPreview.js";
import "react";
import "clsx";
import "../Button/Button.js";
import "next/link";
import "../../_chunks/RadioRatingStarButton.G-PJJfn0.js";
import "js-cookie";
import "../Combobox/Combobox.js";
import "../Datepicker/Datepicker.js";
import "@portabletext/react";
import "../Grid/Col/Col.js";
import "react-is";
import "../IconButton/IconButton.js";
import "next/image";
import "../Input/Input.js";
import "@hookform/error-message";
import "../Modal/constants.js";
import "../Modal/ModalContent.js";
import "../Modal/ModalFooter.js";
import "../Modal/ModalHeader.js";
import "../Modal/ModalContext.js";
import "../RadioButton/RadioButton.js";
import { Skeleton as r } from "../Skeleton/Skeleton.js";
import "../Switch/Switch.js";
import '../../_assets/CheckboxSkeleton.B796aTGF.css';const e = "_root_pfk9k_1", c = "_checkmark_pfk9k_6", k = "_label_pfk9k_12", o = {
  root: e,
  checkmark: c,
  label: k
}, F = ({ withLabel: m, labelWidth: p }) => /* @__PURE__ */ i("div", { className: o.root, children: [
  /* @__PURE__ */ t(r, { className: o.checkmark }),
  m && /* @__PURE__ */ t(r, { width: p, className: o.label })
] });
export {
  F as CheckboxSkeleton
};
